<template lang="pug">
  #listUserBusiness
    .table-view-header
      .table-view-header-title
        h3 Usuarios en empresa
      .table-view-header-actions
        b-button.btn-create(@click="showCreateUserBusinessModal" size="sm" variant="light-muted") + Nuevo
    b-table(:items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(Acciones)="data")
        .table-actions
          b-button(@click="showEditUserBusinessModal(data.value.user)", size="sm", variant="light")
            font-awesome-icon(:icon="['far', 'edit']" size="lg" style="color: #7F828F")
          b-button(@click="showDeleteUserBusinessModal(data.value.user)", size="sm", variant="light")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg" style="color: #7F828F")
    //- Modals
    b-modal(v-model="showCreateModal", size="lg" :hide-footer="true", title="Crear usuario en empresa")
      CreateEditForm(v-if="showCreateModal", :hideModal="hideCreateModal", action="create", :makeToast="makeToast") 
    b-modal(v-model="showEditModal", size="lg" :hide-footer="true", title="Editar usuario en empresa")
      CreateEditForm(v-if="showEditModal", title="Editar usuario", action="edit", :hideModal="hideEditModal", :selectedUser="selectedUser", :makeToast="makeToast")
    b-modal(v-model="showDeleteModal", :hide-footer="true", :hide-header="true")
      DeleteUser(v-if="showDeleteModal", :hideModal="hideDeleteModal", :selected="selectedUser", :makeToast="makeToast")
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CreateEditForm from "./CreateEditForm";
import DeleteUser from "./DeleteUser";
export default {
  components: {
    CreateEditForm,
    DeleteUser
  },
  data() {
    return {
      selectedUser: {},
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false
    };
  },
  computed: {
    ...mapGetters(["business"]),
    tableItems() {
      if (this.business.users) {
        return this.business.users.map(u => {
          return {
            Nombre: `${u.name} ${u.lastName}`,
            Email: u.email,
            Acciones: { user: u }
          };
        });
      }
      return [];
    }
  },
  methods: {
    ...mapActions(["getBusiness"]),
    showEditUserBusinessModal(user) {
      this.selectedUser = user;
      this.showEditModal = true;
    },
    async hideEditModal() {
      this.showEditModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    showDeleteUserBusinessModal(user) {
      this.selectedUser = user;
      this.showDeleteModal = true;
    },
    async hideDeleteModal() {
      this.showDeleteModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    showCreateUserBusinessModal() {
      this.showCreateModal = true;
    },
    async hideCreateModal() {
      this.showCreateModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#listUserBusiness {
  margin-top: 20px;
}
</style>
